import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";

export type ArticlesReadData = number[];

export const QUERY_KEY = "getArticlesRead";

export const useGetArticlesRead = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async (): Promise<ArticlesReadData> => {
      const response = await apiClient.get<ArticlesReadData>(
        API_ROUTES.articlesRead,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
  });
};
